<template>
	<!--  <dv-border-box-13>-->
	<div id="map" style="width:100%;height:400px;padding:10px"></div>
	<!--  </dv-border-box-13>-->
</template>
<script>
export default {
	props: ['table7'],
	data() {
		return {
			geoJson: require('./新疆维吾尔自治区.json'),
			cityData: [
				{
					num: {
						today: 156,
						all: 25946,
					},
					alarm: [30, 12, 30, 300, 40, 60, 20],
					people: [
						{value: 45, name: '有风险人员', itemStyle: {color: '#e6cb3c'}},
						{value: 45, name: '告警人员', itemStyle: {color: 'red'}},
						{value: 206, name: '健康人员', itemStyle: {color: '#67C23A'}},
					]
				},{
					num: {
						today: 199,
						all: 52656,
					},
					alarm: [50, 32, 30, 30, 600, 80, 30],
					people: [
						{value: 15, name: '有风险人员', itemStyle: {color: '#e6cb3c'}},
						{value: 65, name: '告警人员', itemStyle: {color: 'red'}},
						{value: 206, name: '健康人员', itemStyle: {color: '#67C23A'}},
					]
				},{
					"num": {
						"today": 187,
						"all": 32451
					},
					"alarm": [42, 8, 56, 273, 64, 91, 35],
					"people": [
						{"value": 53, "name": "有风险人员", "itemStyle": {"color": "#e6cb3c"}},
						{"value": 38, "name": "告警人员", "itemStyle": {"color": "red"}},
						{"value": 189, "name": "健康人员", "itemStyle": {"color": "#67C23A"}}
					]
				},{
					"num": {
						"today": 213,
						"all": 28765
					},
					"alarm": [55, 17, 42, 341, 78, 53, 29],
					"people": [
						{"value": 67, "name": "有风险人员", "itemStyle": {"color": "#e6cb3c"}},
						{"value": 52, "name": "告警人员", "itemStyle": {"color": "red"}},
						{"value": 198, "name": "健康人员", "itemStyle": {"color": "#67C23A"}}
					]
				},
				{
					"num": {
						"today": 142,
						"all": 31289
					},
					"alarm": [38, 9, 45, 298, 61, 74, 33],
					"people": [
						{"value": 49, "name": "有风险人员", "itemStyle": {"color": "#e6cb3c"}},
						{"value": 56, "name": "告警人员", "itemStyle": {"color": "red"}},
						{"value": 215, "name": "健康人员", "itemStyle": {"color": "#67C23A"}}
					]
				},{
					"num": {
						"today": 198,
						"all": 27543
					},
					"alarm": [47, 14, 39, 312, 58, 67, 24],
					"people": [
						{"value": 51, "name": "有风险人员", "itemStyle": {"color": "#e6cb3c"}},
						{"value": 44, "name": "告警人员", "itemStyle": {"color": "red"}},
						{"value": 203, "name": "健康人员", "itemStyle": {"color": "#67C23A"}}
					]
				}
			]
		};
	},
	created() {
		this.$nextTick(function () {
			this.provinceMap();
		});
	},
	methods: {
		provinceMap() {
			var array = [
				{name: '乌鲁木齐', value: [87.62, 43.82, 95]},
				{name: '克拉玛依', value: [84.87, 45.60, 60]},
				{name: '昌吉', value: [87.30, 44.02, 45]},
				{name: '伊宁', value: [81.32, 43.92, 70]},
				{name: '喀什', value: [76.00, 39.47, 85]},
				{name: '阿克苏', value: [80.27, 41.17, 65]},
				// {name: '和田', value: [79.92, 37.12, 55]},
				// {name: '库尔勒', value: [86.15, 41.77, 75]},
				// {name: '哈密', value: [93.52, 42.83, 50]},
				// {name: '吐鲁番', value: [89.19, 42.95, 40]}
			];

			// 计算最小值和最大值用于大小比例计算
			var values = array.map(item => item.value[2]);
			var minValue = Math.min(...values);
			var maxValue = Math.max(...values);

			// for (let i = 0; i < this.table7.length; i++) {
			// 	let obj = {};
			// 	obj.value = this.table7[i].count;
			// 	obj.name = this.table7[i].name;
			// 	array.push(obj);
			// }

			var echarts = require('echarts');
			var chartDom = document.getElementById('map');
			var myChart = echarts.init(chartDom);

			// debugger
			myChart.showLoading();

			// $.get( 'https://geo.datav.aliyun.com/areas_v2/bound/530000_full.json', function (geoJson) {
			// console.log(geoJson)

			echarts.registerMap('china123', this.geoJson, {});
			myChart.hideLoading();

			let option = {
				tooltip: {
					formatter: '{b}<br/>{c}(人)',
					trigger: 'item', // 触发类型
					show: true,      // 是否显示提示框
					backgroundColor: 'rgba(48, 64, 79, 0.5)', // 背景色
					borderWidth: 0,     // 边框宽度
					padding: 10,        // 内边距
					textStyle: {        // 文本样式
						color: 'white',
						fontSize: 14
					}
				},
				geo: {
					map: 'china123',
					roam: false, // 允许缩放和拖动
					zoom: 1.1, // 初始缩放级别
					label: {
						show: false,
					},
					layoutCenter: ['50%', '50%'], // 地图在容器中的位置
					layoutSize: '100%',
					itemStyle: {
						areaColor: 'rgba(4, 63, 134, 0.3)', // 设置地图区域颜色和透明度
						borderColor: '#2E71B1', // 边界线颜色
						borderWidth: 1 // 边界线宽度
					},
					emphasis: { // 高亮状态下的样式
						label: {
							show: false,
						},
						itemStyle: {
							areaColor: 'rgba(4, 48, 115, 0.8)' // 高亮时更深的颜色
						}
					},
				},
				series: [
					// {
					// 	type: 'map',
					// 	map: 'china123', // 替换为你的地图名称
					// 	zlevel: 1,    // 层级较低
					// 	itemStyle: {
					// 		borderColor: '#0ff', // 发光颜色（亮色）
					// 		borderWidth: 4,     // 较粗的边框
					// 		areaColor: 'transparent', // 填充透明
					// 		opacity: 0.5,       // 透明度控制发光强度
					// 	},
					// 	emphasis: {
					// 		// 可选：高亮时的样式
					// 		itemStyle: {
					// 			borderColor: '#ff0',
					// 			borderWidth: 4,
					// 			opacity: 0.7,
					// 		}
					// 	}
					// },
					// // 上层：正常地图
					// {
					// 	type: 'map',
					// 	map: 'china123',
					// 	zlevel: 2,    // 层级较高，覆盖底层
					// 	itemStyle: {
					// 		borderColor: '#fff', // 正常边框颜色
					// 		borderWidth: 1,      // 正常边框宽度
					// 		areaColor: '#ccc',   // 正常填充色
					// 	},
					// 	emphasis: {
					// 		// 高亮样式（可选）
					// 		itemStyle: {
					// 			areaColor: '#ff0',
					// 		}
					// 	}
					// }
					{
					name: '城市指标',
					type: 'scatter',
					coordinateSystem: 'geo',
					data: array,
					symbolSize: function(val) {
						// 根据数值计算点的大小 (最小20px，最大30px)
						var size = 10 + (val[2] - minValue) / (maxValue - minValue) * 30;
						return Math.max(10, Math.min(30, size));
					},
					label: {
						formatter: '{b}',
						position: 'right',
						show: false
					},
					itemStyle: {
						color: '#CDC87B',
					},
					emphasis: {
						label: {
							show: true
						},
						itemStyle: {
							borderWidth: 2,
							shadowBlur: 10
						}
					},
					tooltip: {
						formatter: function(params) {
							return params.name + '<br/>数值: ' + params.value[2];
						}
					}
				}
				],
			};
			myChart.setOption(option);

			// 监听点击事件
			myChart.on('click',  (params) => {
				// params 是点击事件的相关信息
				console.log('点击了数据点:', params);

				if (params.seriesType === 'scatter') {
					var name = params.name;    // 自定义的额外信息（如果有）
					this.$store.commit('SET_CITY', name);
					this.$store.commit('setCityData', this.cityData[params.dataIndex]);
				}
			});
		},
	},
};
</script>
<style scoped lang="scss">
</style>